export default "__VITE_ASSET__Cyortvxj__"